import { render, staticRenderFns } from "./WidgetTable.vue?vue&type=template&id=3ed16df8&"
import script from "./WidgetTable.vue?vue&type=script&lang=js&"
export * from "./WidgetTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports